import { Reducer } from 'redux';

import { NetworkActivityLoadAction } from '../../domains/networkActivity/actions.types';

import { NetworkActivityLifecycle } from './types';

const initialState: NetworkActivityLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkActivityLifecycle, NetworkActivityLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_ACTIVITY.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'NETWORK_ACTIVITY.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.networkActivity };
    case 'NETWORK_ACTIVITY.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
